/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */

export type VideoVisitStartedPayloadSideEffectType =
  (typeof VideoVisitStartedPayloadSideEffectType)[keyof typeof VideoVisitStartedPayloadSideEffectType];

export const VideoVisitStartedPayloadSideEffectType = {
  video_visit_started: "video_visit_started",
} as const;
